import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";

import Token from "./utilities/jwt/Token";

const routes = [
  {
    path: "/",
    name: "app",
    component: App,
    children: [
      {
        path: "/",
        name: "checklist",
        component: () => import("./pages/checklist/ChecklistView.vue"),
      },
      {
        path: "/veiculos",
        name: "veiculos",
        component: () => import("./pages/vehicle/VehicleView.vue"),
      },
      {
        path: "/documentos",
        name: "documentos",
        component: () => import("./pages/document/DocumentView.vue"),
      },
      {
        path: "/acessorios",
        name: "acessorios",
        component: () => import("./pages/accessory/AccessoryView.vue"),
      },
      {
        path: "/avarias",
        name: "avarias",
        component: () => import("./pages/breakdown/BreakdownView.vue"),
      },
      {
        path: "/pneus",
        name: "pneus",
        component: () => import("./pages/tire/TireView.vue"),
      },
      {
        path: "/motoristas",
        name: "motoristas",
        component: () => import("./pages/driver/DriverView.vue"),
      },
      {
        path: "/log",
        name: "log",
        component: () => import("./pages/log/LogView.vue"),
      },
    ],
  },
  {
    path: "/access-denied",
    name: "access-denied",
    component: () => import("./pages/not_found/AccessDenied.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import("./pages/not_found/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

//VERIFICA SE POSSUI LOCAL NO SESSION STORAGE, SE NÃO, DEVOLVE PARA A TELA DE NÃO AUTORIZADO
//DESCOMENTAR EM PRODUÇÃO
router.beforeEach((to, from, next) => {
  const local = new Token().getCookie('local');
  const token = new Token().getCookie('access_token');
  if (!token && !local && (to.name !== 'access-denied')) {
    next({ name: 'access-denied' });
  } else {
    next();
  }
});

export default router;
